export const prepareUniqueSymbols = <T>(array: T[], field: string): T[] => {
    const seen = new Set();
    return array.filter((item) => {
        if (!item[field as keyof typeof item] || seen.has(item[field as keyof typeof item])) {
            return false;
        }
        seen.add(item[field as keyof typeof item]);
        return true;
    });
};
